<form *ngIf="form && fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">

    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'acm_type.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'acm_type.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/acm-type" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{ ('common.save' | translate) }}"></button>
      </div>
    </div>

    <div class="card">

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.acm_type_code.nullable}">{{ fields.acm_type_code.keyName }}</span>
          <input type="number" min="0" pInputText class="fieldInput" formControlName="acm_type_code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.acm_type_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.flg_operation.nullable}">{{ fields.flg_operation.keyName }}</span>
          <div class="fieldInput">
            <p-dropdown [options]="flg_operations.getOptions()" formControlName="flg_operation"></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.flg_operation"></app-validation-msg>
          </div>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.acm_typei_pid.nullable}">{{ fields.acm_typei_pid.keyName }}</span>
          <div class="fieldInput">
            <p-dropdown [options]="listTypeI" formControlName="acm_typei_pid" ></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.acm_typei_pid"></app-validation-msg>
          </div>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.acm_typeo_pid.nullable}">{{ fields.acm_typeo_pid.keyName }}</span>
          <div class="fieldInput">
            <p-dropdown [options]="listTypeO" formControlName="acm_typeo_pid" ></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.acm_typeo_pid"></app-validation-msg>
          </div>
        </div>

      </div>

      <ng-container *ngIf="editMode">

        <div class="ui-g">
          <div class="ui-g-11 ui-md-11 ui-lg-11">
            <h3 class="step-title">{{ 'common.reason' | translate}}</h3>
          </div>
          <div class="ui-g-12 ui-md-12 ">
            <button pButton (click)="addReason()" icon="fa fa-plus-circle" iconPos="right" type="button" class="k-generic-btn" label="{{ ('common.add' | translate) }}"></button>
          </div>
        </div>

        <div formArrayName="reasons" *ngIf="reasonForm && reasonFields">
          <div class="repeater-panel" *ngFor="let reason of reasons.controls; let i=index" [formGroupName]="i">
            <p-panel>

              <p-header>
                <span class="ui-panel-title">#{{ i + 1 }}</span>
                <button pButton type="button" icon="fa fa-times" (click)="deleteReason(i, reason)" class="ui-button-danger btnDelete"></button>
              </p-header>

              <div class="clearfix">
                <div class="ui-g-12 ui-md-5">
                  <span class="label" [ngClass]="{'required': !reasonFields.reason_id.nullable}">{{ reasonFields.reason_id.keyName }}</span>
                  <p-dropdown [options]="reasonsList" formControlName="reason_id" ></p-dropdown>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="reason" [validation]="reasonFields.reason_id"></app-validation-msg>
                </div>
                <div class="ui-g-12 ui-md-5">
                  <span class="label" [ngClass]="{'required': !reasonFields.grant_role_id.nullable}">{{ reasonFields.grant_role_id.keyName }}</span>
                  <p-dropdown [options]="rolesList" formControlName="grant_role_id"></p-dropdown>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="reason" [validation]="reasonFields.grant_role_id"></app-validation-msg>
                </div>
              </div>

            </p-panel>
          </div>
        </div>

      </ng-container>

    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm-type/form-acm-type-loyalty/form-acm-type-loyalty.component.html